import React, { Component } from 'react';
import cn from 'classnames';
import Autocomplete from 'react-select';
import { arrowRenderer, clearRenderer } from '@lightspeed/cirrus-autocomplete';

// @TODO Move this in a reusable component so we don't have to redo
// the same `handleChange` logic every time we use `react-select`?
export default class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.initialValue || undefined,
      error: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleChange(option) {
    const { onSelectChange } = this.props;

    if (onSelectChange && typeof onSelectChange === 'function') onSelectChange(option);

    this.setState(() => ({
      value: option ? option.value : '',
      error: false,
    }));
  }

  handleInputChange(value) {
    this.setState({ error: false });
    return value;
  }

  render() {
    const { value, error } = this.state;
    const { options, noTranslate, ...rest } = this.props;

    const className = cn({ 'has-error': error });

    const noTranslateProps = noTranslate
      ? {
          optionRenderer: option => <var>{option.label}</var>,
          valueRenderer: option => <var>{option.label}</var>,
        }
      : {};

    return (
      <Autocomplete
        value={value}
        options={options}
        className={className}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        arrowRenderer={arrowRenderer}
        clearRenderer={clearRenderer}
        backspaceRemoves={false}
        clearable={false}
        {...noTranslateProps}
        {...rest}
      />
    );
  }
}
